import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { deleteAdmin } from "../../helper/API/permission";
import * as adminAction from "../../redux/adminList/action";
import { connect } from "react-redux";

const DeleteModal = ({
	open,
	handleClose,
	data,
	setRefresh,
	refresh,
	adminListData,
}) => {
	const [loading, setLoading] = React.useState(false);
	// console.log("data", data);
	const handleSubmit = () => {
		// setLoading(true);
		const submitData = {
			id: data.id,
		};
		// console.log("submit data", submitData);
		deleteAdmin(submitData).then((res) => {
			if (res.success) {
				handleClose();
				adminListData();
				toast.success(res.message);
				setLoading(false);
			} else {
				toast.error(res.message);
				setLoading(false);
			}
		});
	};
	return (
		<div>
			<Dialog fullWidth maxWidth={"sm"} open={open} onClose={handleClose}>
				<DialogTitle>Excluir administrador</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Tem certeza de que deseja excluir o administrador?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						variant='outlined'
						color='inherit'>
						Não
					</Button>
					<Button
						onClick={handleSubmit}
						variant='contained'
						color='error'
						sx={{ position: "relative" }}
						disabled={loading}>
						Sim
						{loading && (
							<CircularProgress
								size={24}
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
									marginTop: "-12px",
									marginLeft: "-12px",
								}}
							/>
						)}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
const mapDispatchToProp = (dispatch) => {
	return {
		adminListData: () => dispatch(adminAction.adminList()),
	};
};
export default connect(null, mapDispatchToProp)(DeleteModal);
